import { render, staticRenderFns } from "./alignEven_off.vue?vue&type=template&id=96dfe5da&"
import script from "./alignEven_off.vue?vue&type=script&lang=ts&"
export * from "./alignEven_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports